const privacynoticeBtn = document.getElementById('tryBtn');
// const label = document.querySelector('[for=' + `form_input_8` + ']');

  privacynoticeBtn.addEventListener('click', gotoURL);

  function gotoURL(){
    // window.open("https://google.com", "_blank");
    alert('Working');
  }